<template>
    <div id="msg-box">

    </div>
</template>

<script>
export default {
    name: 'msgBox',
    data: function() {	
        return {}
    },
    methods: {}
}
</script>

<style lang="less">
#msg-box{
    float: right;
    margin-right: 10px;
    position: relative;
    height: 34px;
    width: 34px;
    box-shadow: 1px 2px 1px rgba(0,0,0,.15);
    background: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/tool/rightTop/msgBox.vue